export default __webpack_public_path__ + "static/media/GaneshchaturtiNew3.5510a4cc.JPG";